class ServerService {
  public static Ping() {
    alert("pingxxxx");
  }
}
export default ServerService;